import { Images } from '@/assets/images';
import { Theme } from '@/theme';
import styled from 'styled-components';

export const SceneContainer = styled.div`
  background-color: ${Theme.color.red};
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;

  margin-bottom: 16.4px;
  position: relative;
  overflow: hidden;

  height: 336px;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: 
      radial-gradient(circle at center, transparent 30%, rgba(0,0,0,0.15) 70%),
      url(${Images.RedGradient});
    background-position: center, center;
    background-repeat: no-repeat;
    opacity: 0.7;
    mix-blend-mode: normal;
    background-size: contain;
    z-index: 0;
  }

  > aside:last-child {
    position: absolute;
  }
`;

export const Canvas = styled.canvas`
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 0;
`;

export const Logo = styled.img`
  transform: translateX(-50%);
  position: absolute;

  width: 80px;
  top: 41.4px;
  z-index: 1;
  left: 50%;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  height: 100%;
  background-image:
    url(${Images.EmptyTape}),
    url(${Images.EmptySilhouette}),
    url(${Images.LabelName});

  background-position:
    50% 78%,
    52% 108%,
    49% 34%;

  background-size:
    100% auto,
    108px 219px,
    29px 24px;

  background-repeat: no-repeat;

  position: relative;
  z-index: 1;
`;

export const Button = styled.button`
  border-radius: 50px;
  margin-bottom: ${Theme.rems(18)};
  padding: ${Theme.rems(20)} ${Theme.rems(24)};
  background-color: ${Theme.color.orange};
  color: ${Theme.color.black};
  font-size: ${Theme.rems(22)};
  font-weight: ${Theme.font.weight.bold};
  line-height: ${Theme.rems(22)};
  text-transform: uppercase;
  font-family: ${Theme.font.family.speedeeCondensed};
  min-width: 200px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PlusIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 8px;
`;
